// removed by extract-text-webpack-plugin
module.exports = {"primary-menu-header":"main_nav-3dg","primary-menu-header-dark":"main_nav-3Ds","primary-menu-header-about":"main_nav-3j5"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Menu/PrimaryMenuHeader/primary_menu_header.module.scss
// module id = 129
// module chunks = 0